import ADD_PRODUCT_SUSTAINABILITY from 'api/mutations/ADD_PRODUCT_SUSTAINABILITY';
import REMOVE_PRODUCT_SUSTAINABILITY from 'api/mutations/REMOVE_PRODUCT_SUSTAINABILITY';
import UPDATE_PRODUCT_SUSTAINABILITY from 'api/mutations/UPDATE_PRODUCT_SUSTAINABILITY';
import GET_PRODUCT_SUSTAINABILITIES from 'api/queries/GET_PRODUCT_SUSTAINABILITIES';
import { createProductParameterSlice } from './createProductParameterSlice';
const productSustainabilitySlice = createProductParameterSlice({
    name: 'productSustainability',
    stateKey: 'productSustainability',
    query: GET_PRODUCT_SUSTAINABILITIES,
    addMutation: ADD_PRODUCT_SUSTAINABILITY,
    updateMutation: UPDATE_PRODUCT_SUSTAINABILITY,
    removeMutation: REMOVE_PRODUCT_SUSTAINABILITY,
    idVariableName: 'productSustainabilityId',
    selectConnection: (data) => data.autocomplete.productSustainabilities,
    selectAddedItem: (data) => data.addProductSustainability.productSustainability,
    selectUpdatedItem: (data) => data.updateProductSustainability.productSustainability,
});
export const resetProductSustainability = productSustainabilitySlice.reset;
export const fetchProductSustainability = productSustainabilitySlice.fetchItems;
export const addProductSustainability = productSustainabilitySlice.addItem;
export const updateProductSustainability = productSustainabilitySlice.updateItem;
export const removeProductSustainability = productSustainabilitySlice.removeItem;
export const selectProductSustainability = productSustainabilitySlice.selectItems;
export const selectProductSustainabilityById = productSustainabilitySlice.selectItemById;
export const selectProductSustainabilityPageInfo = productSustainabilitySlice.selectPageInfo;
export const selectProductSustainabilityStatus = productSustainabilitySlice.selectStatus;
export const selectProductSustainabilityErrors = productSustainabilitySlice.selectErrors;
export const selectProductSustainabilityRefetchFlags = productSustainabilitySlice.selectRefetchFlags;
export default productSustainabilitySlice.reducer;
